var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93755 0C2.65069 0 0 2.65069 0 5.93755C0 8.30555 1.37836 10.3201 3.39289 11.2744V13.3243H8.48222V11.2744C10.4967 10.3201 11.8751 8.27023 11.8751 5.93755C11.8751 2.65069 9.22441 0 5.93755 0ZM5.93755 1.76709C3.64033 1.76709 1.76703 3.64021 1.76703 5.93761C1.76703 6.14967 1.62562 6.29108 1.41356 6.29108C1.20151 6.29108 1.0601 6.14967 1.0601 5.93761C1.06021 3.25154 3.25142 1.06034 5.93737 1.06034C6.14943 1.06034 6.29084 1.20175 6.29084 1.4138C6.29084 1.62586 6.14943 1.76715 5.93737 1.76715L5.93755 1.76709Z",
    fill: "#141320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48228 14.7024C8.48228 14.455 8.27022 14.2429 8.02278 14.2429L3.85256 14.243C3.60512 14.243 3.39307 14.4551 3.39307 14.7025C3.39307 14.95 3.60512 15.162 3.85256 15.162C3.60512 15.162 3.39307 15.3741 3.39307 15.6215C3.39307 15.869 3.60512 16.081 3.85256 16.081H4.3827C4.13526 16.081 3.92321 16.2931 3.92321 16.5405C3.92321 16.7879 4.13526 17 4.3827 17H7.4575C7.70494 17 7.917 16.7879 7.917 16.5405C7.917 16.2931 7.70494 16.081 7.4575 16.081H8.02303C8.27046 16.081 8.48252 15.869 8.48252 15.6215C8.48252 15.3741 8.27046 15.162 8.02303 15.162C8.27035 15.1619 8.4824 14.9499 8.4824 14.7024L8.48228 14.7024Z",
    fill: "#141320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuInsights);
export default __webpack_public_path__ + "static/media/menu-insights.0c56d57ffa7f2c47cffc17aa6aa0ea9e.svg";
export { ForwardRef as ReactComponent };